import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnlinePenampung";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
